import React, { useState, memo, useCallback, useMemo } from "react";
import {
  CargoCargoRevenueExpenseHeader,
  queryPortDisabledFields,
  termsCoEfficientTable,
} from "../../../../constants";
import {
  operationsOptions,
} from "../../../../constants";
import CustomShowModal from "../../../../components/Common/CustomShowModal";
import _ from "lodash";
import { handleKeyDown } from "../../../../common/common";

function Revenue(props) {
  const {
    calculatorData = [],
    onChangeRevenueOperations = () => { },
    freightMode,
  } = props;
  const { customerCargo = {} } = calculatorData || {};
  const [termsModal, setTermsModal] = useState(false);

  const onClickHeaderModal = (headerName) => {
    if (headerName === "Terms") {
      setTermsModal(true);
    }
  };


  const termsToDisplay = termsCoEfficientTable.filter(
    (item) => item.value !== 0
  );

  const styles = (index) => {
    const width = CargoCargoRevenueExpenseHeader[index]?.width;
    return { minWidth: width, width };
  };

  let newPortOperationHeader = [...CargoCargoRevenueExpenseHeader];


  let showModal = ["Dist Normal", "Dist ECA", "Terms", "Supply"];
  const inx = customerCargo?.cargoList?.findIndex(item => item?.operation?.toLowerCase() === "loading");

  return (
    <div style={{ overflow: "auto" }} className="operation-background scroll-thin">
      <div className="port-operation-buttons">

      </div>
      <div className="port-operation-header">
        {newPortOperationHeader.map((item, index) => {
          const isModalField = showModal.includes(item.label);

          return (
            <div
              key={index}
              className="flex items-center"
              style={{
                minWidth: item.width,
                width: item.width,
              }}
            >
              <span
                style={{
                  width: "100%",
                  paddingLeft: item?.paddingLeft,
                  cursor: isModalField ? "pointer" : "default",
                  color: "#ffffff",
                  textDecoration: isModalField ? "underline" : "none",
                  display: "flex",
                  flexDirection: "column",
                }}
                onClick={() => {
                  if (isModalField) {
                    onClickHeaderModal(item.label);
                  }
                }}
              >
                {item.label}
              </span>
            </div>
          );
        })}
      </div>
      <div className="sortable-div">
        {customerCargo?.cargoList &&
          customerCargo?.cargoList.map((operations, index) => {
            const checkDisabled =
              CargoCargoRevenueExpenseHeader[operations.operation] || {};
            const disableForSingleFreight =
              (freightMode === "Single Freight" && index !== inx) || false;
            return (
              <div className="sortable-row-tr cargo-cargo-row" key={index} index={index}>

                <div className="operation-input-div cargo-cargo-div" style={styles(0)}>
                  {/* {operations.operation || 0} */}
                  <select
                    value={operations.operation || ""}
                    name="operation"
                    onChange={(e) => onChangeRevenueOperations(index, e)}
                    disabled={true}
                  >
                    {operationsOptions.map((option, key) => (
                      <option
                        key={key}
                        value={option.value}
                        disabled={option.isDisabled}
                      >
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="operation-input-div cargo-cargo-div" style={styles(1)}>
                  <p
                    className="add-three-dots"
                  >
                    {operations.port || ""}
                  </p>
                </div>

                <div className="operation-input-div cargo-cargo-div" style={styles(2)}>
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={operations.rate || ""}
                    // disabled={!!checkDisabled.rate}
                    name="rate"
                    placeholder="0"
                    onChange={(e) => onChangeRevenueOperations(index, e)}
                  />
                </div>
                <div className="operation-input-div cargo-cargo-div" style={styles(3)}>
                  <select
                    value={operations.terms || ""}
                    name="terms"
                    onChange={(e) => onChangeRevenueOperations(index, e)}
                    disabled={checkDisabled.terms}
                  >
                    {termsCoEfficientTable.map((option, key) => (
                      <option key={key} value={option.label}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="operation-input-div cargo-cargo-div" style={styles(4)}>

                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={operations.turnTime || ""}
                    name="turnTime"
                    placeholder=""
                    onChange={(e) => onChangeRevenueOperations(index, e)}
                  />
                </div>

                <div className="operation-input-div cargo-cargo-div" style={styles(5)}>
                  {/*  rate MT day */}
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={operations.freight || ""}
                    // disabled={!!checkDisabled.freight}
                    disabled={
                      queryPortDisabledFields?.[operations?.operation]?.[
                      "freight"
                      ] || disableForSingleFreight
                    }
                    name="freight"
                    placeholder=""
                    onChange={(e) => onChangeRevenueOperations(index, e)}
                  />
                </div>

                <div className="operation-input-div cargo-cargo-div" style={styles(6)}>
                  {/* {operations.portExp} */}
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={operations.adcom || ""}
                    // disabled={!!checkDisabled.adcom}
                    disabled={
                      queryPortDisabledFields?.[operations?.operation]?.["adcom"] ||
                      disableForSingleFreight
                    }
                    name="adcom"
                    placeholder="0"
                    onChange={(e) => onChangeRevenueOperations(index, e)}
                  />
                </div>
                <div className="operation-input-div cargo-cargo-div" style={styles(7)}>
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={operations.other || ""}
                    // disabled={!!checkDisabled.other}
                    disabled={
                      queryPortDisabledFields?.[operations?.operation]?.["other"] ||
                      disableForSingleFreight
                    }
                    name="other"
                    placeholder="0"
                    onChange={(e) => onChangeRevenueOperations(index, e)}
                  />
                </div>
                <div className="operation-input-div cargo-cargo-div" style={styles(8)}>
                  {/*  Port Emission */}
                  <input
                    type="text"
                    onKeyDown={handleKeyDown}
                    value={operations.brokerage || ""}
                    // disabled={!!checkDisabled.brokerage}
                    disabled={
                      queryPortDisabledFields?.[operations?.operation]?.[
                      "brokerage"
                      ] || disableForSingleFreight
                    }
                    name="brokerage"
                    placeholder="0"
                    onChange={(e) => onChangeRevenueOperations(index, e)}
                  />
                </div>
                <div className="operation-input-div cargo-cargo-div" style={styles(9)}>
                  <input
                    type="text"
                    // onKeyDown={handleKeyDown}
                    value={operations.account || ""}
                    // disabled={!!checkDisabled.account}
                    disabled={
                      queryPortDisabledFields?.[operations?.operation]?.["account"]
                    }
                    name="account"
                    placeholder=""
                    onChange={(e) => onChangeRevenueOperations(index, e)}
                  />
                </div>
                <div className="operation-input-div cargo-cargo-div" style={styles(10)}>
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={operations.demurrageRate || ""}
                    // disabled={!!checkDisabled.demurrageRate}
                    name="demurrageRate"
                    placeholder="0"
                    onChange={(e) => onChangeRevenueOperations(index, e)}
                  />
                </div>
                <div className="operation-input-div cargo-cargo-div" style={styles(11)}>
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={operations.despatchRate || ""}
                    // disabled={!!checkDisabled.despatchRate}
                    name="despatchRate"
                    placeholder="0"
                    onChange={(e) => onChangeRevenueOperations(index, e)}
                  />
                </div>
                <div className="operation-input-div cargo-cargo-div" style={styles(12)}>
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={operations.additionalRevenue || ""}
                    // disabled={!!checkDisabled.additionalRevenue}
                    name="additionalRevenue"
                    placeholder="0"
                    onChange={(e) => onChangeRevenueOperations(index, e)}
                  />
                </div>
                <div className="operation-input-div cargo-cargo-div" style={styles(13)}>
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={operations.additionalExpense || ""}
                    // disabled={!!checkDisabled.additionalExpense}
                    name="additionalExpense"
                    placeholder="0"
                    onChange={(e) => onChangeRevenueOperations(index, e)}
                  />
                </div>
                <div className="operation-input-div cargo-cargo-div" style={styles(14)}>
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={operations.laytimeIncurred ?? ""}
                    // disabled={!!checkDisabled.laytimeIncurred}
                    name="laytimeIncurred"
                    placeholder="0"
                    onChange={(e) => onChangeRevenueOperations(index, e)}
                  />
                </div>
              </div>
            );
          })}
      </div>
      <CustomShowModal
        open={termsModal}
        handleClose={() => setTermsModal(false)}
        maxWidth="none"
        title="Terms Co-efficient Table"
      >
        <div className="w-[260px] border border-slate-300 rounded-none overflow-hidden my-0.5">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-[#f0f2f5] border-b border-slate-300">
                <th className="px-2.5 py-1 text-[11px] font-medium text-slate-700 border-r border-slate-300">
                  Terms (Contract Type)
                </th>
                <th className="px-2.5 py-1 text-[11px] font-medium text-slate-700 text-right">
                  Multiplier (Factor)
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 bg-white">
              {termsToDisplay.map((term, index) => (
                <tr key={index} className="hover:bg-slate-50 transition-colors">
                  <td className="px-2.5 py-0.5 text-[11px] font-medium text-slate-800 border-r border-slate-200">
                    {term.label}
                  </td>
                  <td className="px-2.5 py-0.5 text-[11px] font-medium text-slate-800 text-right">
                    {term.value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CustomShowModal>

    </div>
  );
}

export default memo(Revenue);
